
// BlogPage.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Search, BookOpen, ChevronDown, FileText } from "lucide-react";
import Konn3ctHeader from "../Header & Footer/Konn3ctHeader";
import Footer from "../Header & Footer/kfooter";
import blogPosts from "./KBlogs";

const categories = ["All", "Education", "How To", "Konn3ct AI"];

const BlogPage = () => {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const [isOpen, setIsOpen] = useState(false);

  const filteredBlogs = blogPosts.filter((post) => {
    const matchesCategory = category === "All" || post.category === category;
    const matchesSearch = post.title.toLowerCase().includes(search.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen flex flex-col text-gray-800 overflow-hidden pt-[64px] sm:pt-[80px] md:pt-[100px]">
      <Konn3ctHeader />

      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-20 py-10">
        {/* Filters */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-10 max-w-4xl mx-auto">
        
          {/* Search */}
       
          <div className="w-full md:w-1/2 lg:w-2/5 sm:w-[70%]">
            <div className="flex items-center bg-white rounded-full shadow-sm border border-gray-200 px-4 py-2">
              <Search className="w-5 h-5 text-gray-400 mr-3" />
              <input
                type="text"
                placeholder="Search blogs..."
                className="flex-1 bg-transparent outline-none text-gray-700 placeholder-gray-500"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>

          {/* Custom Dropdown */}
          <div className="relative ">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="w-full md:w-60 gap-2 flex items-center justify-between bg-white border border-gray-200 rounded-full px-4 py-2 font-semibold text-gray-600 shadow-sm hover:shadow transition-all focus:outline-none"
            >
              <span>{category === "All" ? "All Categories" : category}</span>
              <ChevronDown
                className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            {isOpen && (
              <div className="absolute top-full mt-2 w-full md:w-64 bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden z-10">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    onClick={() => {
                      setCategory(cat);
                      setIsOpen(false);
                    }}
                    className={`w-full text-left px-6 py-3 text-gray-700 hover:bg-[#1A4699]/5 transition ${
                      category === cat ? "bg-[#1A4699]/10 font-semibold text-[#1A4699]" : ""
                    }`}
                  >
                    {cat === "All" ? "All Categories" : cat}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Blog Grid OR Empty State */}
        {filteredBlogs.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {/* {filteredBlogs.map((post) => (
              <div
                key={post.id}
                className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-56 object-cover hover:scale-110 transition-transform duration-500"
                  />
                  <span className="absolute top-4 left-4 bg-black/70 text-white text-xs px-3 py-1.5 rounded-full">
                    {post.category}
                  </span>
                </div>

                <div className="p-6">
                  <h3 className="font-bold text-xl text-gray-900 line-clamp-2 mb-3">
                    {post.title}
                  </h3>

                  <p className="flex items-center gap-2 text-sm text-gray-500 mb-4">
                    <BookOpen className="w-4 h-4" />
                    {post.readTime}
                  </p>

                  <p className="text-gray-600 text-sm leading-relaxed line-clamp-3 mb-5">
                    {post.description}
                  </p>

                  <Link
                    to={`/blog/${post.id}`}
                    className="inline-block text-[#1A4699] font-semibold text-sm hover:underline"
                  >
                    Read More →
                  </Link>
                </div>
              </div>
            ))} */}

 {filteredBlogs.map((post) => (
            <div key={post.id} className=" bg-white ">
              {/* IMAGE */}

              <div className="rounded-xl overflow-hidden shadow bg-white">
                <div className="relative w-full h-48">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />

                  {/* Category tag */}
                  <span className="absolute top-3 left-3 bg-black/60 text-white text-xs px-2 py-1 rounded">
                    {post.category}
                  </span>
                </div>
              </div>

              {/* TEXT CONTENT */}
              <div className="p-4">
                <h3 className="font-semibold text-lg mb-1 text-gray-900">
                  {post.title}
                </h3>

                <p className="flex gap-2 text-xs text-gray-500 mb-3">
                  {" "}
                  <BookOpen className="w-4 h-4" /> {post.readTime}
                </p>

                <p className="text-sm text-gray-600 leading-relaxed mb-4 line-clamp-3">
                  {post.description}
                </p>

                <Link
                  to={`/blog/${post.id}`}
                  className="text-blue-700 text-sm font-medium hover:underline"
                >
                  Read More →
                </Link>
              </div>
            </div>
          ))}


          </div>
        ) : (
          /* Empty State — Beautiful & Friendly */
          <div className="text-center py-20 max-w-2xl mx-auto">
            <div className="bg-gray-100 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6">
              <FileText className="w-12 h-12 text-gray-400" />
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-3">
              No blogs found
            </h3>
            <p className="text-gray-600">
              {search
                ? `No results for "${search}"`
                : `No blogs in "${category}" category yet`}
            </p>
            <button
              onClick={() => {
                setSearch("");
                setCategory("All");
              }}
              className="mt-6 px-6 py-3 bg-[#1A4699] text-white rounded-full font-medium hover:bg-[#1A4699]/90 transition"
            >
              Show All Blogs
            </button>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default BlogPage;












// // BlogPage.jsx
// import React, { useState } from "react";
// import { Link } from "react-router-dom"; // ← Add this
// import { Search, BookOpen, ChevronDown } from "lucide-react";
// import Konn3ctHeader from "../Components/Konn3ctHeader";
// import Footer from "../Components/kfooter";
// import blogPosts from "../Data/KBlogs"; // ← Import shared data

// const categories = ["All", "Education", "How To", "Konn3ct AI"];

// const BlogPage = () => {
//   const [search, setSearch] = useState("");
//   const [category, setCategory] = useState("All");
  // const [isOpen, setIsOpen] = useState(false);


//   const filteredBlogs = blogPosts.filter((post) => {
//     const matchesCategory = category === "All" || post.category === category;
//     const matchesSearch = post.title
//       .toLowerCase()
//       .includes(search.toLowerCase());
//     return matchesCategory && matchesSearch;
//   });

//   return (
//     <div className="min-h-screen flex flex-col text-gray-800">
//       <Konn3ctHeader />

//       <div className="w-full px-4 sm:px-6 md:px-10 lg:px-20 py-10">
//         {/* Filters */}
//         <div className="flex flex-col md:flex-row justify-center gap-4 mb-10 items-center max-w-4xl mx-auto">

//           <div className="flex items-center w-full md:w-2/4 bg-white rounded-full shadow-sm border border-gray-200 px-4 py-2">
//             <Search className="w-5 h-5 text-gray-400 mr-3" />
//             <input
//               type="text"
//               placeholder="Search blogs..."
//               className="flex-1 bg-transparent outline-none text-sm text-gray-700"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//           </div>

//           <select
//             className="w-full md:w-1/4 border rounded-full px-4 py-2 cursor-pointer bg-white"
//             value={category}
//             onChange={(e) => setCategory(e.target.value)}
//           >
//             {categories.map((cat) => (
//               <option key={cat} value={cat}>
//                 {cat}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* GRID - Clickable Cards */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
//           {filteredBlogs.map((post) => (
//             <div key={post.id} className=" bg-white ">
//               {/* IMAGE */}

//               <div className="rounded-xl overflow-hidden shadow bg-white">
//                 <div className="relative w-full h-48">
//                   <img
//                     src={post.image}
//                     alt={post.title}
//                     className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
//                   />

//                   {/* Category tag */}
//                   <span className="absolute top-3 left-3 bg-black/60 text-white text-xs px-2 py-1 rounded">
//                     {post.category}
//                   </span>
//                 </div>
//               </div>

//               {/* TEXT CONTENT */}
//               <div className="p-4">
//                 <h3 className="font-semibold text-lg mb-1 text-gray-900">
//                   {post.title}
//                 </h3>

//                 <p className="flex gap-2 text-xs text-gray-500 mb-3">
//                   {" "}
//                   <BookOpen className="w-4 h-4" /> {post.readTime}
//                 </p>

//                 <p className="text-sm text-gray-600 leading-relaxed mb-4 line-clamp-3">
//                   {post.description}
//                 </p>

//                 <Link
//                   to={`/blog/${post.id}`}
//                   className="text-blue-700 text-sm font-medium hover:underline"
//                 >
//                   Read More →
//                 </Link>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default BlogPage;



























































































// import React, { useState } from "react";
// import { MapPin, Search, ChevronDown } from "lucide-react";
// import SearchHeader from "../Components/SearchHeader";
// import Konn3ctHeader from "../Components/Konn3ctHeader";
// import Footer from "../Components/kfooter";

// const blogPosts = [

// ];

// const categories = ["All", "Education", "How To", "Konn3ct AI"];

// const BlogPage = () => {
//   const [search, setSearch] = useState("");
//   const [category, setCategory] = useState("All");

//   const filteredBlogs = blogPosts.filter((post) => {
//     const matchesCategory = category === "All" || post.category === category;

//     const matchesSearch = post.title
//       .toLowerCase()
//       .includes(search.toLowerCase());

//     return matchesCategory && matchesSearch;
//   });

//   return (
//       <div className="min-h-screen flex flex-col text-gray-800">
//                   <Konn3ctHeader />

//     <div className="w-full px-4 sm:px-6 md:px-10 lg:px-20 py-10 ">
//       {/* Filters */}
//       <div className="flex flex-col max-w-4xl md:flex-row justify-center gap-4 mb-10 items-center">

//         <div className="flex items-center w-2/4 bg-white rounded-full shadow-sm border border-gray-200 px-4 py-2">
//           <Search className="w-5 h-5 text-gray-400 mr-2" />

//           <input
//             type="text"
//             placeholder="  Search..."
//             //   className="border rounded-xl px-4 py-2 w-full md:w-1/3"
//             className="flex-1 bg-transparent outline-none text-sm text-gray-700"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//           />
//         </div>
//         <select
//           className="border rounded-xl px-4 py-2 w-1/4 cursor-pointer"
//           value={category}
//           onChange={(e) => setCategory(e.target.value)}
//         >
//           {categories.map((cat) => (
//             <option key={cat}>{cat}</option>
//           ))}
//         </select>
//       </div>

//       {/* GRID */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//         {filteredBlogs.map((post) => (
//           <div key={post.id} className=" bg-white">
//             {/* IMAGE */}

//             <div className="rounded-xl overflow-hidden shadow bg-white">
//               <div className="relative w-full h-48">
//                 <img
//                   src={post.image}
//                   alt={post.title}
//                   className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
//                 />

//                 {/* Category tag */}
//                 <span className="absolute top-3 left-3 bg-black/60 text-white text-xs px-2 py-1 rounded">
//                   {post.category}
//                 </span>
//               </div>
//             </div>

//             {/* TEXT CONTENT */}
//             <div className="p-4">
//               <h3 className="font-semibold text-lg mb-1">{post.title}</h3>

//               <p className="text-xs text-gray-500 mb-3">⏱ {post.time}</p>

//               <p className="text-sm text-gray-600 leading-relaxed mb-4">
//                 {post.description}
//               </p>

//               <a
//                 href="##"
//                 className="text-blue-700 text-sm font-medium hover:underline"
//               >
//                 Read More →
//               </a>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//      <Footer />
//     </div>
//   );
// };

// export default BlogPage;

// // BlogPage.jsx
// import React, { useState } from "react";
// import { Link } from "react-router-dom"; // ← Add this
// import img1 from "../Images/Konn3ct Images/Rectangle 6322.png";
// import { Search } from "lucide-react";
// import Konn3ctHeader from "../Components/Konn3ctHeader";
// import Footer from "../Components/kfooter";

// const blogPosts =
//   [
//   {
//     id: 1,
//     slug: "integer-maecenas-eget-viverra-1",
//     title: "Integer Maecenas Eget Viverra",
//     category: "Education",
//     time: "4 min read",
//     date: "March 15, 2025",
//     author: "Sarah Johnson",
//     authorRole: "Content Writer, Konn3ct",
//     image: img1,
//     description: "Aenean eleifend ante maecenas pulvinar montes lorem et pede...",
//     content: `Aenean eleifend ante maecenas pulvinar montes lorem et pede dictum. Vel consequat justo sem... (full article here)`
//   },
//   // Add more with unique slug and full content...
//   // (I'll give you 3 full ones below)
// ];

// const categories = ["All", "Education", "How To", "Konn3ct AI"];

// const BlogPage = () => {
//   const [search, setSearch] = useState("");
//   const [category, setCategory] = useState("All");

//   const filteredBlogs = blogPosts.filter((post) => {
//     const matchesCategory = category === "All" || post.category === category;
//     const matchesSearch = post.title.toLowerCase().includes(search.toLowerCase());
//     return matchesCategory && matchesSearch;
//   });

//   return (
//     <div className="min-h-screen flex flex-col">
//       <Konn3ctHeader />

//       <div className="w-full px-4 sm:px-6 md:px-16 lg:px-32 py-12">
//         {/* Filters */}
//         <div className="flex flex-col md:flex-row justify-center gap-6 mb-12 max-w-5xl mx-auto">
//           <div className="flex items-center flex-1 max-w-md bg-white rounded-full shadow-sm border border-gray-200 px-5 py-3">
//             <Search className="w-5 h-5 text-gray-400 mr-3" />
//             <input
//               type="text"
//               placeholder="Search blogs..."
//               className="flex-1 outline-none text-gray-700"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//           </div>

//           <select
//             className="px-6 py-3 rounded-xl border border-gray-300 bg-white cursor-pointer"
//             value={category}
//             onChange={(e) => setCategory(e.target.value)}
//           >
//             {categories.map((cat) => (
//               <option key={cat} value={cat}>{cat}</option>
//             ))}
//           </select>
//         </div>

//         {/* Blog Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
//           {filteredBlogs.map((post) => (
//             <Link
//               key={post.id}
//               to={`/blog/${post.id}`}
//               className="group block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
//             >
//               <div className="relative overflow-hidden">
//                 <img
//                   src={post.image}
//                   alt={post.title}
//                   className="w-full h-56 object-cover group-hover:scale-110 transition-transform duration-500"
//                 />
//                 <span className="absolute top-4 left-4 bg-black/70 text-white text-xs px-3 py-1.5 rounded-full">
//                   {post.category}
//                 </span>
//               </div>

//               <div className="p-6">
//                 <h3 className="font-bold text-xl text-gray-900 group-hover:text-[#1A4699] transition">
//                   {post.title}
//                 </h3>
//                 <p className="text-sm text-gray-500 mt-2">Time {post.time}</p>
//                 <p className="text-gray-600 text-sm mt-3 line-clamp-3">
//                   {post.description}
//                 </p>
//                 <span className="inline-block mt-4 text-[#1A4699] font-medium hover:underline">
//                   Read More →
//                 </span>
//               </div>
//             </Link>
//           ))}
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default BlogPage;

// import React, { useState } from "react";
// import img1 from "../Images/Konn3ct Images/Rectangle 6322.png"

// const blogPosts = [
//   {
//     id: 1,
//     title: "Integer Maecenas Eget Viverra",
//     category: "Education",
//     time: "4 min read",
//     image: img1,
//     description:
//       "Aenean eleifend ante maecenas pulvinar montes lorem et pede. Aenean eleifend ante maecenas pulvinar montes lorem et pede dictum.",
//   },
//   {
//     id: 2,
//     title: "Integer Maecenas Eget Viverra",
//     category: "How To",
//     time: "4 min read",
//     image: img1,
//     description:
//       "Aenean eleifend ante maecenas pulvinar montes lorem et pede. Vel consequat justo sem.",
//   },
//   {
//     id: 3,
//     title: "Integer Maecenas Eget Viverra",
//     category: "Konn3ct AI",
//     time: "4 min read",
//     image: img1,
//     description:
//       "Aenean eleifend ante maecenas pulvinar montes lorem et pede dictum consequa.",
//   },
//   {
//     id: 4,
//     title: "Integer Maecenas Eget Viverra",
//     category: "How To",
//     time: "4 min read",
//     image: img1,
//     description:
//       "Aenean eleifend ante maecenas pulvinar montes lorem et pede dictum.",
//   },
//   {
//     id: 5,
//     title: "Integer Maecenas Eget Viverra",
//     category: "Konn3ct AI",
//     time: "4 min read",
//     image: img1,
//     description:
//       "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia.",
//   },
//   {
//     id: 6,
//     title: "Integer Maecenas Eget Viverra",
//     category: "Education",
//     time: "4 min read",
//     image: img1,
//     description:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Veniamet egestas luctus lorem.",
//   },
// ];

// const categories = ["All", "Education", "How To", "Konn3ct AI"];

//  const BlogPage = () => {
//   const [search, setSearch] = useState("");
//   const [category, setCategory] = useState("All");

//   const filteredBlogs = blogPosts.filter((post) => {
//     const matchesCategory =
//       category === "All" || post.category === category;

//     const matchesSearch = post.title
//       .toLowerCase()
//       .includes(search.toLowerCase());

//     return matchesCategory && matchesSearch;
//   });

//   return (
//     <div className="w-full px-4 sm:px-6 md:px-10 lg:px-20 py-10">

//       {/* ---------- Top Filters ---------- */}
//       <div className="flex flex-col md:flex-row justify-between gap-4 mb-10">

//         {/* Search */}
//         <input
//           type="text"
//           placeholder="🔍  Search..."
//           className="border rounded-xl px-4 py-2 w-full md:w-1/3"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />

//         {/* Category Dropdown */}
//         <select
//           className="border rounded-xl px-4 py-2 w-full md:w-1/4 cursor-pointer"
//           value={category}
//           onChange={(e) => setCategory(e.target.value)}
//         >
//           {categories.map((cat) => (
//             <option key={cat}>{cat}</option>
//           ))}
//         </select>
//       </div>

//       {/* ---------- Blog Grid ---------- */}
//       <div className="
//           grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8
//         "
//       >
//         {filteredBlogs.map((post) => (
//           <div
//             key={post.id}
//             className="rounded-xl shadow hover:shadow-lg transition overflow-hidden bg-white"
//           >
//             {/* Image */}
//             <div className="relative">
//               <img
//                 src={post.image}
//                 alt={post.title}
//                 className="w-full h-48 object-cover"
//               />

//               {/* Category Tag */}
//               <span className="
//                 absolute top-3 left-3 bg-black/70 text-white text-xs px-2 py-1 rounded
//               ">
//                 {post.category}
//               </span>
//             </div>

//             {/* Content */}
//             <div className="p-4">
//               <h3 className="font-semibold text-lg mb-1">
//                 {post.title}
//               </h3>

//               <p className="text-xs text-gray-500 mb-3">
//                 ⏱ {post.time}
//               </p>

//               <p className="text-sm text-gray-600 leading-relaxed mb-4 line-clamp-3">
//                 {post.description}
//               </p>

//               <a
//                 href="###"
//                 className="text-blue-700 text-sm font-medium hover:underline"
//               >
//                 Read More →
//               </a>
//             </div>
//           </div>
//         ))}
//       </div>

//     </div>
//   );
// }

// export default BlogPage;
